export default __webpack_public_path__ + "static/media/vocabulary-game-icon.7d063427.png";